<template>
  <div>
    <pricing-blocks :header-text="page.template.introductie" :pakketten="page.template.pakketten"/>

    <section class="container flex justify-center mb-24">
      <div class="w-full md:w-3/4 flex flex-wrap">
        <div class="w-full lg:flex-1 mr-4 mb-6 lg:mb-0 prose content" v-html="page.template.tekst"/>
      </div>
    </section>

    <mentor-quickview
      header-txt="Zoek de begeleider die bij jou past"
    />
  </div>
</template>

<script>
import MentorQuickview from '~/components/begeleiders/MentorQuickview';
import PricingBlocks from '~/components/ouders/PricingBlocks';
import page from '~/plugins/mixins/page';

export default {
  components: {PricingBlocks, MentorQuickview},
  mixins: [page],
};
</script>
